import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCcy8tyYTzJ7Qb54n_xwjQ3LTcCsfd0zx4",
  authDomain: "mynewprojectesc.firebaseapp.com",
  projectId: "mynewprojectesc",
  storageBucket: "mynewprojectesc.appspot.com",
  messagingSenderId: "295249025385",
  appId: "1:295249025385:web:18bcbca55dd204cf3505f8",
  measurementId: "G-YBH5E80FWB"
};



const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };

